import rfdc from 'rfdc'

export const clone = rfdc({
    circles: false,
    proto: true,
})